import { deviceListModel } from "../../models/model";
import { actionTypes } from "../action/action";

const initialState = {
  aciveDevicesList: []
};

export const deviceListReducer = (state: deviceListModel = initialState, action: any) => {
  switch (action.type) {
   
      case actionTypes.DEVICE_LIST:
        return{
          ...state, aciveDevicesList:action.payload.aciveDevicesList
        };

    default:
      return state;
    }
}